// @flow

import React from "react";
import { Portal } from "@chakra-ui/react";

import List from "./List";
import CurrentSelection from "./CurrentSelection";
import {
  Overlay,
  Container,
  Content as StyledContent,
} from "src/styles/splitPane";

import Close from "src/containers/Close";

const OrgSettings = () => {
  // const userPermissions = useSelector(({ app }) => getUserPermissions(app));
  // const checkSSOViewPermission = useCallback(() => {
  //   userPermissions.resourcePermissions.includes(`119-${verb.get}`);
  // }, []);

  const isViewSSOAllowed = true;

  return (
    <Portal>
      <Close />
      <Overlay style={{ overflowX: "hidden" }}>
        <Container>
          <List isSSOViewAllowed={isViewSSOAllowed} />
          <StyledContent>
            <CurrentSelection isSSOViewAllowed={isViewSSOAllowed} />
          </StyledContent>
        </Container>
      </Overlay>
    </Portal>
  );
};

export default OrgSettings;
